const RISK_CASE_SCORE_FIELDS = [
  "dead_sum_score",
  "sick_sum_score",
  "disable_sum_score",
  "accident_sum_score",
  "fire_sum_score",
  "car_accident_sum_score",
];

/**
 * ถือว่าแผนความเสี่ยงเสร็จแล้วเมื่ออย่างน้อยหนึ่งกรณีมีคะแนนชนิด number
 * ที่เป็น finite และมากกว่าศูนย์ เพื่อไม่ให้ object หรือค่าผิดชนิดถูกนับเป็นแผนที่เสร็จแล้ว
 *
 * @param {Record<string, unknown> | null | undefined} riskData
 * @returns {boolean}
 */
export const hasCompletedRiskPlan = (riskData) =>
  RISK_CASE_SCORE_FIELDS.some((scoreField) => {
    const score = riskData?.[scoreField];

    return Number.isFinite(score) && score > 0;
  });
